<template>
  <div class="agent">
    <Banner :banner="banner" />
    <div class="w1320">
      <div class="title">
        <div class="cn">授权代理</div>
        <div class="en">Authorized Agent</div>
      </div>
      <div class="container">
        <div class="menu">
          <div class="item" :class="{active:currentTab=='condition'}" @click="currentTab='condition'">加盟条件</div>
          <div class="item" :class="{active:currentTab=='apply'}" @click="currentTab='apply'">加盟申请</div>
        </div>
        <div class="content">
          <component :is="currentTab"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'
import condition from './condition.vue'
import apply from './apply.vue'
export default {
  components: {
    Banner,
    condition,
    apply
  },
  data(){
    return{
      banner:{
        title:'授权代理',
        img:'/images/agentbanner.jpg'
      },
      currentTab:'condition'
    }
  }
}
</script>

<style scoped>
.agent .title{
  text-align: center;
  padding: 45px 0;
}
.agent .title .cn{
  font-family: '宋体';
  font-size: 30px;
  color: #5e7987;
  margin-bottom: 10px;
}
.agent .title .en{
  font-family: 'Embassy BT';
  font-size: 20px;
  color: #636363;
}
.agent .container{
  display: flex;
}
.agent .container .menu{
  width: 350px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.agent .container .menu .item{
  font-size: 14px;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
}
.agent .container .menu .item::before{
  content: '';
  position: absolute;
  left: 100%;
  top: 50%;
  width: 74px;
  height: 1px;
  background-color: #d5d5d5;
  transition: 1s;
  opacity: 0;
}
.agent .container .menu .item::after{
  content: '';
  position: absolute;
  left: 100%;
  top: 50%;
  margin-left: 74px;
  margin-top: -3px;
  width: 8px;
  height: 8px;
  background-color: #000;
  border-radius: 50%;
  transition: 1s;
  opacity: 0;
}
.agent .container .menu .item.active::before,
.agent .container .menu .item:hover::before,
.agent .container .menu .item.active::after,
.agent .container .menu .item:hover::after{
  opacity: 1;
}
.agent .container .content{
  width: 680px;
}
@media(max-width: 768px){
  .agent .container{
    flex-wrap: wrap;
  }
  .agent .container .menu,
  .agent .container .content{
    width: 100%;
  }
  .agent .container .menu{
    flex-direction: row;
    justify-content: center;
  }
  .agent .container .menu .item+.item{
    margin-left: 20px;
  }
  .agent .container .menu .item::before,
  .agent .container .menu .item::after{
    display: none;
  }
  .agent .container .menu .item.active{
    color: #5e7987;
  }
  .agent .container .content{
    padding: 0 20px;
  }
}
</style>


